import { createFileRoute } from "@tanstack/react-router";

import { FinancePage } from "@/features/payments/components/finance-page";
import { financeSearchSchema, financeTabs } from "@/features/payments/lib/finance";

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/finance")({
  validateSearch: financeSearchSchema,
  component: FinanceRoute,
});

function FinanceRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const closeClaim = () =>
    void navigate({
      search: (prev) => ({ ...prev, claim: undefined, claimTab: undefined }),
      replace: true,
      resetScroll: false,
    });

  return (
    <FinancePage
      tab={search.tab ?? financeTabs[0]}
      // The first tab is the absent state, so it never lands in the URL.
      onTabChange={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, tab: next === financeTabs[0] ? undefined : next }),
          replace: true,
        })
      }
      claimPreview={search.claim ? { claimId: search.claim, tab: search.claimTab ?? "overview" } : null}
      // Same toggle as /signatures: clicking the open claim again closes the panel.
      onOpenClaim={(claimId) =>
        search.claim === claimId
          ? closeClaim()
          : void navigate({
              search: (prev) => ({ ...prev, claim: claimId, claimTab: "overview" as const }),
              resetScroll: false,
            })
      }
      onClaimTabChange={(claimTab) =>
        void navigate({ search: (prev) => ({ ...prev, claimTab }), replace: true, resetScroll: false })
      }
      onCloseClaim={closeClaim}
    />
  );
}
